import { Card, CardContent, CardMedia, Grid, Typography } from "@mui/material";
import styles from "./InfoCard.module.css";

interface InfoCardProps {
  cardImage: any;
  icon: any;
  headerText: string;
  infoText: string;
  buttonText: string;
  dataTestId: string;
  videoLinkForPortal?: string;
  isDisabled?: boolean;
  actionButtons: React.ReactNode[];
  footerText?: React.ReactNode;
}

export const InfoCard = ({
  cardImage,
  headerText,
  infoText,
  dataTestId,
  actionButtons,
  footerText
}: InfoCardProps) => {
  return (
    <Card data-testid={dataTestId}>
      <CardContent className={styles.cardContent}>
        <CardMedia
          component="img"
          className={styles.cardMedia}
          image={cardImage}
          alt="recipe image"
        />
        <Typography variant="h2" className={styles.headerText}>{headerText}</Typography>
        <Typography variant="body2" className={styles.infoText}>{infoText}</Typography>
        <Grid container spacing={2} style={{display: "flex", justifyContent: "center"}}>
          {actionButtons.map((button, index) => (
            <Grid item>{button}</Grid>
          ))}
        </Grid>
        {footerText}
      </CardContent>
    </Card>
  );
};
